import React, { useMemo } from 'react'
import { ClickAwayListener, makeStyles } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { InfographicBlock } from '../../components/previews/InfographicBlock'
import { usePreviewDisplayContext } from '../../components/PreviewDisplayContext'
import { SelectedReportObjectEditCard } from './SelectedReportObjectEditCard'

const useStyles = makeStyles({
  displayContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '1rem',
    position: 'relative'
  },
  displayContainerInner: {
    flex: '0 0',
    position: 'relative',
    border: 'var(--border-neutral-normal)',
    background: 'var(--color-neutral-200)',
    padding: '1rem',
    minWidth: 'fit-content',
    zIndex: 100,
    borderRadius: 'var(--border-radius-sm)'
  }
})

export const InfographicBlockDisplay = () => {
  const classes = useStyles()
  const { infographicBlockId } = useParams()
  const { watch, setValue } = useFormContext()
  const { setSelectedReportObjectId } = usePreviewDisplayContext()
  const metadata = watch('metadata')
  const content = watch('content')
  const runtimeConfigValues = watch('runtimeConfigValues')

  const infographicBlock = useMemo(() => ({
    infographicBlockId,
    runtimeConfigValues,
    content
  }), [infographicBlockId, runtimeConfigValues, content])

  return (
    <>
      <ClickAwayListener onClickAway={() => setSelectedReportObjectId(null)} mouseEvent='onMouseUp'>
        <div className={classes.displayContainer}>
          <div className={classes.displayContainerInner}>
            <InfographicBlock
              infographicBlock={infographicBlock}
              containerSize={metadata?.size ?? { rows: 16, cols: 12 }}
              onChangeContent={(content) => setValue('content', content)}
              normalizeContent={false}
            />
          </div>
          <SelectedReportObjectEditCard />
        </div>
      </ClickAwayListener>
    </>
  )
}
